import $ from 'jquery';

import ChairishABTest from 'chairisher/abtest';
import createProductRail from 'chairisher/view/helper/rail';
import FavoriteProductView from 'chairisher/view/product/favorite';

import { getSaleUrl } from 'chairisher/context/product';
import { ProductRailType } from 'chairisher/util/analytics';

/**
 * AB Test that shows a personalized rail at the top of the Sale page to help users quickly find relevant products
 * and increase conversion. The rail uses the same logic as Temp Sale emails and is visible to all users.
 *
 * TODO: (CHAIR-17960) Delete file after AB test is complete.
 */
export default class TempSaleRailTest extends ChairishABTest {
    static getExperimentName() {
        return 'TEMP_SALE_RAIL_AB_TEST';
    }

    variation() {
        const railWrapperIdSelector = '#js-temp-sale-rail-wrapper';
        const $railWrapperEl = $(railWrapperIdSelector);
        const railIdSelector = '#js-temp-sale-rail';
        const $railContainerEl = $(railIdSelector);
        const $collectionTitle = $('.js-collection-header .collection-title');
        const $railSelectorEl = $(`${railIdSelector}-scrollable-grid`);

        $railWrapperEl.removeClass('hidden');
        $collectionTitle.text('All On Sale');

        createProductRail({
            $el: $railSelectorEl,
            $containerEl: $railContainerEl,
            analyticsTrackingType: ProductRailType.ALL_SALE,
            listSelector: railIdSelector,
            railUrl: getSaleUrl(),
            onRendered: () => {
                $railContainerEl.find('.js-product').each((i, el) => {
                    const $productEl = $(el);
                    if ($productEl.data('is-favorited')) {
                        const id = $productEl.data('product-id');
                        FavoriteProductView.addProductId(id, false);
                        FavoriteProductView.drawButton(true, id);
                    }
                });
                if ($railContainerEl.hasClass('hidden')) {
                    $railWrapperEl[0].style.height = '0';
                    // TODO: If this A/B test is implemented permanently, revisit this logic to find a better way to avoid CLS issues.
                }
            },
        });
        $railSelectorEl.addClass('is-scroller'); // TODO: If this A/B test is implemented, revisit this logic.
    }
}
